import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src", "width", "height"]

import apiClient from "@/api/api";
import useUser from "@/composables/useUser";
import { ref } from 'vue';
import { Monitoring } from "@/utilities/monitoring";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatComponent',
  props: {
    width: {
        type: String,
        required: false,
        default: '100%'
    },
    height: {
        type: String,
        required: false,
        default: '500'
    },
    rocketChatUrl: {
        type: String,
        required: true,
    }
},
  setup(__props) {

const props = __props;


const user = useUser().user;
const loginDone = ref(false);
const urlWithToken= ref("");
const authToken = ref("");

apiClient.post( `/organisations/log-in-to-chat/?userId=${user?.value?.id}`).then((response: any) => {   
    if (response.data.authToken) {
        authToken.value = response.data.authToken;
        urlWithToken.value = `${props.rocketChatUrl}&resumeToken=${authToken.value}`;
        loginDone.value = true;
    }
}).catch((error: any ) => {
    Monitoring.consoleOnly("login to rocketchat error", error);
    loginDone.value = false;
});


return (_ctx: any,_cache: any) => {
  return (loginDone.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("iframe", {
          src: urlWithToken.value,
          frameborder: "0",
          width: __props.width,
          height: __props.height,
          allow: "autoplay; camera; microphone"
        }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})